import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertMessageComponent } from '../../shared/components/alert-message/alert-message.component';
import { SpinnerComponent } from '../../shared/components/spinner/spinner.component';
import { finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AlertMessageComponent, SpinnerComponent]
})
export class LoginComponent {
  loginForm: FormGroup;
  showError = signal<boolean>(false);
  isLoading = signal<boolean>(false);
  forgotPasswordUrl = environment.forgotPasswordUrl;

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly authService: AuthService
  ) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  onLogin(): void {
    if (this.loginForm.valid) {
      this.isLoading.set(true);
      this.showError.set(false);
      
      const { username, password } = this.loginForm.value;
      
      this.authService.login(username, password)
        .pipe(
          finalize(() => this.isLoading.set(false))
        )
        .subscribe({
          next: () => {
            this.router.navigate(['/transactions']);
          },
          error: (error) => {
            this.showError.set(true);
          }
        });
    } else {
      this.showError.set(true);
    }
  }
}